import { useAuthStore } from '@/stores/AuthStore'
import router from '@/router'
import { useEventStore } from '@/stores/EventStore'
import { navigateToCurrentTaskPage } from './navigateToCurrentTaskPage'

export function navigateToStartPage() {
  const authStore = useAuthStore()
  const eventStore = useEventStore()

  if (authStore.deviceIsAuthenticated && authStore.isTerminalDevice) {
    return router.push({ name: 'deviceHome' })
  } else if (authStore.deviceIsAuthenticated && authStore.isTeamDevice) {
    if (eventStore.atLeastOneTeamMemberIsClockedIn) {
      return navigateToCurrentTaskPage()
    } else {
      return router.push({ name: 'teamleaderSelection' })
    }
  } else if (authStore.deviceIsAuthenticated && authStore.isPersonalDevice) {
    return navigateToCurrentTaskPage()
  } else {
    return router.push({ name: 'start' })
  }
}
